query pricesForCompany($input: PricesForCompanyInput!) {
  pricesForCompany(input: $input) {
    readableId
    currency
    value
  }
}
